module.exports = {
  live: true
};



// WEBPACK FOOTER //
// ./src/config.js